(function() {
    'use strict';

a3_cabin_reports.directive('specificCombinations',SpecificCombinations);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name SpecificCombinations
   * @restrict E
   * @description
   *   Implementation of Specific Combinations
   *
   *   Initialize the Specific Combinations of a season
   * @example
   *   Usage:
   *   <specific-combinations season-configuration="seasonConfiguration"  season-requests="seasonRequests"></specific-combinations>
   * @ngInject
   */    
function SpecificCombinations($filter) {
    
    function link(scope, element, attrs){
        scope.IsEditEnabled = false;
        scope.selectEditablePeriod = selectEditablePeriod;
        scope.updateEditablePeriod = updateEditablePeriod;
        scope.removeSpecificCombination = removeSpecificCombination;
        scope.addNewSpecificCombination = addNewSpecificCombination;
        scope.getBorderClass = getBorderClass;
        scope.selectedSlotTemp = null;
        scope.isDisabled = isDisabled;
        
        scope.specificCombinations = $filter('filter')(scope.seasonRequests, {Type: 'All'});
        
        scope.sortableOptions = {
            handle: '> .row .myHandle',
            update: function(e, ui) {
             
            },
            stop: function(e, ui) {
                 recalculatePriorities();
            }
        };
        
        
        
       function recalculatePriorities(){
           for(var i=0;i<scope.specificCombinations.length;i++){
             scope.specificCombinations[i].Priority = i+1;
            }
       }
            
        function selectEditablePeriod(period,request){
            if(!period.isEditable){
                resetEditablePeriods();
                if(period.LeaveRequestPrioritySlots && period.LeaveRequestPrioritySlots.length>0){
                    scope.selectedSlotTemp = period.LeaveRequestPrioritySlots[0];
                }else {
                    scope.selectedSlotTemp = null;
                }
                scope.selectedRequestTemp = request;
                scope.selectedSlotDaysTemp = period.Days;
                period.isEditable = true;
                scope.IsEditEnabled = true;
            }else{
                resetEditablePeriods();
            }
        }
        
        function getBorderClass(request){
            var hasEmptyFields = false;
            var hasFilledFields = false;
            var cssClass= "";
               for (var i=0; i< request.LeaveRequestPriorityPeriods.length;i++){
                   hasEmptyFields = hasEmptyFields || (!request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length==0);
                    hasFilledFields = hasFilledFields || !(!request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length==0);
                 
               }
                
            if(hasEmptyFields && hasFilledFields ){
                cssClass = 'specific-combination-orange'
                request.HasInvalidPeriod = true;
            }else if(hasEmptyFields && !hasFilledFields){
                cssClass ='specific-combination-blue'
                request.HasInvalidPeriod = false;
            }else if (hasFilledFields && !hasEmptyFields){
                cssClass ='specific-combination-green'
                request.HasInvalidPeriod = false;
            }
            
            return  cssClass;
        }
        
        function isDisabled(slot){
            var CSSclass="";
            if(scope.selectedRequestTemp){
                for (var i=0; i< scope.selectedRequestTemp.LeaveRequestPriorityPeriods.length;i++){
                    if( scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots &&                 
                        scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length>0 && (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].Id == slot.Id || 
                          (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].EndDay >=slot.StartDay &&
                            scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].StartDay <= slot.EndDay
                          )                                                                                             )
                       ){
                         CSSclass="disabled";
                         break;
                    }
                }
                
            }
           
            return CSSclass;
            
        }
        
        
        function resetEditablePeriods(){
            for(var i=0;i<scope.seasonRequests.length;i++){
                for(var j=0;j<scope.seasonRequests[i].LeaveRequestPriorityPeriods.length;j++){
                    scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable=false;
                }    
            }
           scope.IsEditEnabled = false;
        }
        
        function updateEditablePeriod(slot){
            for(var i=0;i<scope.seasonRequests.length;i++){
                for(var j=0;j<scope.seasonRequests[i].LeaveRequestPriorityPeriods.length;j++){
                    if( scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable && slot && slot.Code){
                            scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots=[slot];
                    } 
                }    
            }
            
            
            resetEditablePeriods();
        }
        
        function removeSpecificCombination(priority){
            var indexOfRemovedObj = null;
            for(var i=0;i<scope.seasonRequests.length;i++){
                if (scope.seasonRequests[i].Priority == priority){
                    indexOfRemovedObj = i;
                }
            }
            if(indexOfRemovedObj !=null){
                scope.seasonRequests.splice(indexOfRemovedObj,1);
                scope.specificCombinations = $filter('filter')(scope.seasonRequests, {Type: 'All'});
                recalculatePriorities();
            }
            
        }
        
        function addNewSpecificCombination(){
            var newSpecificCombinationPriority = 1;
            if (scope.specificCombinations && scope.specificCombinations.length > 0){
               newSpecificCombinationPriority = scope.specificCombinations.length + 1;
            }
            var newObj= {   Type : "All",
                            Priority: newSpecificCombinationPriority,
                            LeaveRequestPriorityPeriods : []
                        }
                    
            scope.seasonRequests.push(newObj);
            
            updateLeaveRequestSeason();
            
            scope.specificCombinations = $filter('filter')(scope.seasonRequests, {Type: 'All'});
            scope.IsEditEnabled = false;
              
        }
        
        function updateLeaveRequestSeason(){
            scope.seasonConfiguration.ConfigurationId = scope.seasonConfiguration.Configuration.Id
             for(var i=0;i<scope.seasonRequests.length; i++ ){
                for(var j=0;j<scope.seasonConfiguration.Configuration.Periods.length; j++ ){
                    scope.seasonConfiguration.Configuration.Periods[j].ConfigurationPeriodId = scope.seasonConfiguration.Configuration.Periods[j].Id
                }
                if(scope.seasonRequests[i].LeaveRequestPriorityPeriods && scope.seasonRequests[i].LeaveRequestPriorityPeriods.length == 0){                 
                    scope.seasonRequests[i].LeaveRequestPriorityPeriods= JSON.parse(JSON.stringify(scope.seasonConfiguration.Configuration.Periods));         
                }
             }
        }
        
        
    }
        
   return {
        restrict: 'E',
        terminal: true,
        templateUrl: 'views/LeaveRequest/specificCombinations.tpl.html',
        scope : {
            seasonConfiguration: '<',
            seasonRequests : '=',
            editable: '<'
        },
        link: link
    }
}

})();